import React, { useState } from 'react';
import CardBack from './back';
import CardFront from './front';

const Card = ({ card }) => {
  const [showFrontSide, setShowFrontSide] = useState(true);

  return (
    <>
      {showFrontSide ? (
        <CardFront card={card} onClick={() => setShowFrontSide(false)} />
      ) : (
        <CardBack card={card} onClick={() => setShowFrontSide(true)} />
      )}
    </>
  );
};

export default Card;
